<template>
  <div style="height:100%;background: #fff;margin:10px">
    <!-- <img class="default_img"
         src="../../assets/images/default.jpg"
         alt=""> -->
    <h1 class="fontL">{{titleName?titleName:''}}信息管理系统</h1>
    <h1 class="fontR">{{date}}</h1>
  </div>
</template>
<script>
export default {
  name: 'defaultPage',
  props: {},
  data () {
    return {
      date: "",
      titleName:localStorage.titleName
    }
  },
  mounted () {
    this.Timer();
  },
  methods: {
    Timer() {
      var timerID = setInterval(this.updateTime, 1000);
      this.updateTime();
      return timerID;
    },
    updateTime() {
      var cd = new Date();
      this.time =
        this.zeroPadding(cd.getHours(), 2) +
        ":" +
        this.zeroPadding(cd.getMinutes(), 2) +
        ":" +
        this.zeroPadding(cd.getSeconds(), 2);
      this.date =
        this.zeroPadding(cd.getFullYear(), 4) +
        "/" +
        this.zeroPadding(cd.getMonth() + 1, 2) +
        "/" +
        this.zeroPadding(cd.getDate(), 2) +
        " " +
        this.time;
    },
    zeroPadding(num, digit) {
      var zero = "";
      for (var i = 0; i < digit; i++) {
        zero += "0";
      }
      return (zero + num).slice(-digit);
    }
  }
}
</script>
<style lang="stylus" scoped>
.default_img
  width 100%
  height 100%
.fontL
  font-size 52px
  padding-top 18%
  margin 0
  color #4199cc
.fontR
  color #4199cc
  margin-top 20px
  font-size 36px
</style>



// WEBPACK FOOTER //
// src/views/defaultPage/defaultPage.vue